// Пример улучшения динамической загрузки компонентов
// Это позволит загружать компоненты на лету без пересборки

// Создайте файл: src/utils/dynamicLoader.js

/**
 * Динамическая загрузка компонентов с сервера
 * Позволяет обновлять компоненты без пересборки всего приложения
 */

// Кэш для загруженных компонентов
const componentCache = new Map();

/**
 * Загружает компонент динамически
 * @param {string} componentPath - Путь к компоненту относительно src/
 * @returns {Promise<React.Component>}
 */
export const loadComponent = async (componentPath) => {
  // Проверяем кэш
  if (componentCache.has(componentPath)) {
    return componentCache.get(componentPath);
  }

  try {
    // В development режиме используем стандартный импорт
    if (process.env.NODE_ENV === 'development') {
      const module = await import(`../${componentPath}`);
      const Component = module.default || module[Object.keys(module)[0]];
      componentCache.set(componentPath, Component);
      return Component;
    }

    // В production режиме можно загружать с сервера
    // Это требует настройки сервера для отдачи JS модулей
    const response = await fetch(`/dynamic-components/${componentPath}`);
    if (response.ok) {
      const code = await response.text();
      // Выполняем код (требует настройки безопасности!)
      const module = eval(code); // ⚠️ Осторожно! Только для доверенных источников
      const Component = module.default || module[Object.keys(module)[0]];
      componentCache.set(componentPath, Component);
      return Component;
    }

    throw new Error(`Failed to load component: ${componentPath}`);
  } catch (error) {
    console.error(`Error loading component ${componentPath}:`, error);
    // Fallback на стандартный импорт
    const module = await import(`../${componentPath}`);
    return module.default || module[Object.keys(module)[0]];
  }
};

/**
 * Очищает кэш компонентов (для перезагрузки)
 */
export const clearComponentCache = () => {
  componentCache.clear();
};

/**
 * Перезагружает конкретный компонент
 */
export const reloadComponent = async (componentPath) => {
  componentCache.delete(componentPath);
  return loadComponent(componentPath);
};


